export default __webpack_public_path__ + "static/media/guide3.064067d6.webp";